export const defaultInputValidationPaneButtonGroupStyles = {
  gap: "10px"
};